import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from 'react-select';

import {
  faAngleDown,
  faAngleUp,
  faGripVertical,
  faLayerGroup,
} from '@fortawesome/free-solid-svg-icons'

import {
  FormFieldsProps,
} from '../../utils/functionsInterfaces'

import { Draggable, Droppable } from '@hello-pangea/dnd'
import { Field } from '../fields'
import { InputsInfosGroups } from '../ui/inputs'
import { ButtonAddField, ButtonAddFieldAttachments, ButtonCopyGroup, ButtonRemoveGroup } from '../ui/buttons'

import { handleAddField } from '../../functions/addFieldStandard'
import { handleAddFieldAttachments } from '../../functions/addFieldAttachments'
import { handleAddPersonalDetailField } from '../../functions/addFieldPersonalDetails'
import { handleCopyGroup } from '../../functions/copyGroup'
import { handleRemoveGroup } from '../../functions/removeGroup'
import { toggleGroupVisibility } from '../../functions/toggleGroupVisibility'
import { useEffect, useState } from 'react';

export default function FormFields({
  form,
  setForm,
  groups,
  handleRemoveField,
  handleRemoveFieldInGroup,
  setButtonSave,
  authorization,
  clientId,
  ambient,
  formId,
  item,
  index,
  outsideTheGroup,
  expandedGroups,
  setAddFieldPersonalDetails,
  setExpandedGroups,
  addFieldPersonalDetails
}: FormFieldsProps) {


  interface CustomerDetailsOption {
    value: string;
    label: string;
  }
  const [selectedOption, setSelectedOption] = useState<CustomerDetailsOption | null>(null);
  const [customerDetailsOption, setCustomerDetailsOption] = useState('')
  const [dupCounts, setDupCounts] = useState<Record<string, number>>({});
  const [dupOpen, setDupOpen] = useState<Record<string, boolean>>({});

  const clientOptionsCustomerDetails = [
    { value: 'customerSocialNumber', label: 'Document' },
    { value: 'customerEmail', label: 'Email' },
    { value: 'customerPhoneNumber', label: 'Phone' },
    { value: 'customerName', label: 'Name' }
  ];

  const getDupCount = (key?: string) => {
    if (!key) return 1;
    return Math.max(1, dupCounts[key] ?? 1);
  };

  const setDupCount = (key: string | undefined, value: number) => {
    if (!key) return;
    const next = Math.min(Math.max(Math.floor(value || 1), 1), 200);
    setDupCounts((prev) => ({ ...prev, [key]: next }));
  };

  const isDupOpen = (key?: string) => {
    if (!key) return false;
    return !!dupOpen[key];
  };

  const toggleDupOpen = (key: string | undefined, open?: boolean) => {
    if (!key) return;
    setDupOpen((prev) => ({ ...prev, [key]: typeof open === 'boolean' ? open : !prev[key] }));
  };

  useEffect(() => {
    const onMouseDown = (e: MouseEvent) => {
      const target = e.target as Node;
      if (target instanceof Element && (target.closest('.form-group-dup') || target.closest('.form-group-dup-trigger'))) return;
      setDupOpen({});
    };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, []);

  return (
    <Droppable droppableId={`${item.uuid}`} key={item.uuid} type="group">
      {(provided) => (
        <div ref={provided.innerRef} {...provided.droppableProps} >
          {((item.children || []).filter((f: any) => !f._deleted) as any[]).map((fieldInGroup: any, indexInGroup: number) => (
            <Draggable
              draggableId={`${fieldInGroup.uuid}`}
              index={indexInGroup}
              key={fieldInGroup.uuid}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >

                  {fieldInGroup.type === 'group' ? (
                    <div key={indexInGroup} className="form-group-card">

                      <div className="form-group-header">
                        <div className="form-group-header-left">
                          <span className="form-field-drag" title="Arraste para reordenar">
                            <FontAwesomeIcon icon={faGripVertical} />
                          </span>
                          <span className="form-group-icon">
                            <FontAwesomeIcon icon={faLayerGroup} />
                          </span>
                          <div className="form-group-inputs">
                            <InputsInfosGroups
                              placeholder='Digite o ID do grupo'
                              value={fieldInGroup.id}
                              onChange={(e) => {
                                const newId = e.target.value
                                const updatedForm = form.map((group: any) =>
                                  group.uuid === item.uuid
                                    ? { ...group, children: (group.children || []).map((field: any) => field.uuid === fieldInGroup.uuid ? { ...field, id: newId } : field) }
                                    : group
                                )
                                setForm(updatedForm)
                              }}
                              onBlur={() => {
                                setButtonSave(true)
                              }}
                            />

                            <InputsInfosGroups
                              placeholder='Digite o nome do grupo'
                              value={fieldInGroup.name}
                              onChange={(e) => {
                                const newName = e.target.value
                                const updatedForm = form.map((group: any) =>
                                  group.uuid === item.uuid
                                    ? { ...group, children: (group.children || []).map((field: any) => field.uuid === fieldInGroup.uuid ? { ...field, name: newName } : field) }
                                    : group
                                )
                                setForm(updatedForm)
                              }}
                              onBlur={() => {
                                setButtonSave(true)
                              }}
                            />
                          </div>
                        </div>

                        <div className="form-group-actions">
                          <ButtonAddField
                            onClick={() => {
                              handleAddField(
                                fieldInGroup.uuid,
                                expandedGroups,
                                form,
                                setForm,
                                setButtonSave
                              )
                              setExpandedGroups([...expandedGroups, fieldInGroup.uuid])
                            }
                            }
                          />

                          <ButtonAddFieldAttachments
                            onClick={() => {
                              handleAddFieldAttachments(
                                fieldInGroup.uuid,
                                expandedGroups,
                                form,
                                setForm,
                                setButtonSave
                              )
                              setExpandedGroups([...expandedGroups, fieldInGroup.uuid])
                            }}
                          />

                          {isDupOpen(fieldInGroup.uuid) && (
                            <div className="form-group-dup">
                              <input
                                type="number"
                                min={1}
                                max={200}
                                value={getDupCount(fieldInGroup.uuid)}
                                onChange={(e) => setDupCount(fieldInGroup.uuid, Number(e.target.value))}
                                onBlur={() => toggleDupOpen(fieldInGroup.uuid, false)}
                                title="Quantidade para duplicar"
                              />
                              <span>x</span>
                            </div>
                          )}

                          <ButtonCopyGroup
                            onClick={() => {
                              if (!isDupOpen(fieldInGroup.uuid)) {
                                toggleDupOpen(fieldInGroup.uuid, true);
                                return;
                              }
                              handleCopyGroup(
                                fieldInGroup.id,
                                fieldInGroup.name,
                                form,
                                setForm,
                                fieldInGroup.uuid || '',
                                setButtonSave,
                                getDupCount(fieldInGroup.uuid)
                              );
                              toggleDupOpen(fieldInGroup.uuid, false);
                            }}
                          />

                          <ButtonRemoveGroup
                            onClick={() =>
                              handleRemoveGroup(
                                fieldInGroup.id,
                                form,
                                setForm,
                                fieldInGroup.uuid,
                                setButtonSave
                              )
                            }
                          />

                          <Select<CustomerDetailsOption>
                            options={clientOptionsCustomerDetails}
                            value={selectedOption}
                            onChange={(newValue) => {
                              if (newValue && 'value' in newValue) {
                                setCustomerDetailsOption(newValue.value);
                                setSelectedOption(newValue);
                                handleAddPersonalDetailField(
                                  fieldInGroup.id,
                                  expandedGroups,
                                  form,
                                  setForm,
                                  newValue.value,
                                  setAddFieldPersonalDetails,
                                  setButtonSave
                                )
                              } else {
                                setCustomerDetailsOption('');
                                setSelectedOption(null);
                              }
                            }}
                            placeholder="Customer"
                            inputId="customer-details-select-search"
                            className="w-full bg-text-field-select"
                            styles={{
                              container: (base) => ({
                                ...base,
                                minWidth: '100px',
                                maxWidth: '150px',
                                marginLeft: '0.5rem',
                                marginRight: '0.5rem',
                              }),
                            }}
                            classNamePrefix="react-select"
                          />

                          <button
                            type='button'
                            onClick={() =>
                              toggleGroupVisibility(
                                fieldInGroup.uuid,
                                expandedGroups,
                                setExpandedGroups
                              )
                            }
                            className="form-structure-toggle"
                            title='Esconder Campos'
                          >
                            {expandedGroups.includes(fieldInGroup.uuid) ? (
                              <FontAwesomeIcon icon={faAngleUp} />
                            ) : (
                              <FontAwesomeIcon icon={faAngleDown} />
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="form-group-body">
                        <FormFields
                          form={form}
                          setForm={setForm}
                          groups={groups}
                          handleRemoveField={handleRemoveField}
                          handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                          setButtonSave={setButtonSave}
                          setAddFieldPersonalDetails={setAddFieldPersonalDetails}
                          authorization={authorization}
                          clientId={clientId}
                          ambient={ambient}
                          formId={formId}
                          item={fieldInGroup}
                          index={indexInGroup}
                          outsideTheGroup={outsideTheGroup}
                          expandedGroups={expandedGroups}
                          setExpandedGroups={setExpandedGroups}
                          addFieldPersonalDetails={addFieldPersonalDetails}
                        />
                      </div>

                    </div>
                  ) : fieldInGroup.fieldType === 'multiple_files' ? (
                    /* campo de anexo fora do grupo */
                    <Field
                      fieldGroupInGroup={fieldInGroup}
                      indexFieldGroupInGroup={indexInGroup}
                      index={index}
                      field={fieldInGroup}
                      handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                      handleRemoveField={handleRemoveField}
                      form={form}
                      setForm={setForm}
                      outsideTheGroup={false}
                      isPersonalDetail={false}
                      setButtonSave={setButtonSave}
                      authorization={authorization}
                      clientId={clientId}
                      ambient={ambient}
                      formId={formId}
                      groupId={item.id}
                      groupUuid={item.uuid}
                    />
                  ) : fieldInGroup.fieldType === 'personal_details' ? (
                    /* campo personal details fora do grupo */
                    <Field
                      fieldGroupInGroup={fieldInGroup}
                      indexFieldGroupInGroup={indexInGroup}
                      index={index}
                      field={fieldInGroup}
                      handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                      handleRemoveField={handleRemoveField}
                      form={form}
                      setForm={setForm}
                      outsideTheGroup={false}
                      isPersonalDetail={true}
                      setButtonSave={setButtonSave}
                      authorization={authorization}
                      clientId={clientId}
                      ambient={ambient}
                      formId={formId}
                      groupId={item.id}
                      groupUuid={item.uuid}
                    />
                  ) : (
                    /* campo padrao fora do grupo */
                    <Field
                      fieldGroupInGroup={fieldInGroup}
                      indexFieldGroupInGroup={indexInGroup}
                      index={index}
                      field={fieldInGroup}
                      handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                      handleRemoveField={handleRemoveField}
                      form={form}
                      setForm={setForm}
                      outsideTheGroup={false}
                      isPersonalDetail={false}
                      setButtonSave={setButtonSave}
                      authorization={authorization}
                      clientId={clientId}
                      ambient={ambient}
                      formId={formId}
                      groupId={item.id}
                      groupUuid={item.uuid}
                    />
                  )}

                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  )

}